import { h } from "preact";
import { Link } from 'react-router-dom'
import AlertBox from '../../../_common/components/AlertBox/AlertBox'
import { useParams } from 'react-router'
import { ButtonGhost } from '../../../_common/components/buttons/buttons'
import { useState } from 'preact/hooks'
import Modal from '../../../_common/components/Modal/index'
import { SCHEDULE_FCT } from '../../../home/HelpSection/ModalHelp/constants'
import StepSchedule from '../../../home/HelpSection/ModalHelp/StepSchedule'
import { t } from '../../../_i18n'
import { useSelector } from 'react-redux'
import {isSpanishUser} from "../../../_common/utils/getLang";
import useFctMeta from "../../hooks/useFctMeta";
import {exemption_100} from "../../../_rx/exemption100-CATMAD-2425/reducers";
import usePrecontractMeta from "../../hooks/useFctMeta";

const ModalSchedule = ({ visible, onClose }) => (
  <Modal visible={visible} closeModal={onClose}>
    <div className='p-all'>
      <div className='d-flex flex-space-between'>
        <div className='font-30'>{t('Reservar cita')}</div>
        <div className='icon cursor-pointer' onClick={onClose}><i className='fal fa-times'/></div>
      </div>
      <div>
        <StepSchedule schedule={SCHEDULE_FCT} />
      </div>
    </div>
  </Modal>
)

export default function AlertContact () {
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const shopId = useSelector(state => state.status.student_meta.shop_id);
  const screenStatus = useSelector(state => state.fct.screenState);
  const screenStatusPrecontract = useSelector(state => state.exemption_100.proto_meta);
  const regulations_pdf_name = screenStatus?.screen_data?.regulations?.name ? screenStatus.screen_data.regulations.name : screenStatusPrecontract.regulations.name;
  const regulations_link = screenStatus?.screen_data?.regulations?.link ? screenStatus.screen_data.regulations.link : screenStatusPrecontract.regulations.link;
  const path = screenStatus?.screen_data?.regulations?.name ? `/fct/${id}/normativa` : `/exemption/${id}/normativa`;

  return (
    <AlertBox type='shadow' className='m-top'>
        {(() => {
            if (isSpanishUser(shopId)) {
                return (
                    <p>{t('Si tienes alguna duda puedes')} <a href={regulations_link} target='_blank' className='font-color-149BAB'>{t('consultar la normativa de FCT')} { regulations_pdf_name }</a>.</p>
                );
            } else if(shopId == 24 || shopId == 44) {
                return (
                    <p>{t('Si tienes alguna duda puedes')} <Link to={{pathname: path}} className='txt-color-primary t-underline font-medium'>{t('consultar la normativa de FCT')} { regulations_pdf_name }</Link>.</p>
                );
            }
        })()}

        <p>{t('También puedes contactar con nosotros a través del número')} <span
            className='font-bold'>{t('91 901 59 29')}</span>. {t('Nuestro horario de atención es de lunes a jueves, desde las 9:00 hasta las 14:00 y desde las 15:00 hasta las 17:30. Los viernes, estamos disponibles de 9:00 a 14:00. Si lo deseas, puedes reservar una cita telefónica y uno de nuestros gestores te llamará.')}</p>
        {isSpanishUser(shopId) && <ButtonGhost className='inverse m-top-x2' onClick={() => setOpenModal(true)}>{t('Reservar cita')}</ButtonGhost>}
      {openModal && <ModalSchedule onClose={() => setOpenModal(false)} visible={openModal} />}
    </AlertBox>
  )
}
